export const isLoggedIn = () => {
  let user = localStorage.getItem('user');
  let email = localStorage.getItem('email');
  let googleLogin = localStorage.getItem('googleLogin');

  return (user || email || googleLogin)
};
